export class DynamicLink {
  constructor(link) {
    this._link = link
    this._regExp = /{([^}]+)}/g
  }

  get link() {
    return this._link
  }

  get isItemLink() {
    return this._link ? this.findParameters().length > 0 : false
  }

  findParameters() {
    let found = []
    let curMatch = this._regExp.exec(this._link)
    while (curMatch) {
      found.push(curMatch[1])
      curMatch = this._regExp.exec(this._link)
    }

    return found
  }

  buildLink(row) {
    let parameters = this.findParameters()
    let dynamicLink = this._link

    for (let parameter of parameters) {
      dynamicLink = dynamicLink.replace('{' + parameter + '}', row[parameter])
    }

    return dynamicLink
  }
}

export default { DynamicLink }
